import { callGet, callPost, callPut } from "../integrations/calls";

import { REQ } from "../../libs/constants";

export const getNozelSale = async (data, token) => {
  return await callPost(REQ.SALE_DATA.GET_SALE, data, token);
};

export const getAllNozel = async (token) => {
    return await callGet(REQ.SALE_DATA.GET_NOZEL,  token);
  };

  export const getAllTank = async (token) => {
    return await callGet(REQ.SALE_DATA.GET_TANK,  token);
  };

  export const updateTankBal = async (data, token) => {
    return await callPut(`${REQ.SALE_DATA.UPDATE_TANK}/${data.id}`, data, token)
}
